// Memory only: the key arrives with design_system on every boot, long before
// a player can reach a pack page, and a reload re-fetches it.
let current: string | null = null;
const listeners = new Set<() => void>();

function notify(): void {
  for (const cb of listeners) cb();
}

/**
 * The operator's public embed_key as handed over by design_system. Only a
 * launch URL carrying `?embed_key=` gives the iframe one directly; a
 * session-token launch gets it from here instead.
 */
export function loadDemoEmbedKey(): string | null {
  return current;
}

export function saveDemoEmbedKey(raw: unknown): void {
  const next = typeof raw === 'string' && raw.length > 0 ? raw : null;
  if (next === current) return;
  current = next;
  notify();
}

export function clearDemoEmbedKey(): void {
  saveDemoEmbedKey(null);
}

export function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
